import api from "../store/services/api";

const getDevices = () => api.get("/new/devices/");

const getDeviceDetails = (deviceId) => api.get(`/devices/${deviceId}/`);

const getMyDevices = () => api.get("/new/devices/my_devices/");

const registerDevice = (data) => api.post("/new/devices/register/", data);

const revokeDevice = (deviceId) => api.post(`/new/devices/${deviceId}/revoke/`);

const regenerateToken = (deviceId) =>
  api.post(`/devices/${deviceId}/regenerate_token/`);

const updateDevice = (deviceId, data) =>
  api.put(`/new/devices/${deviceId}/`, data);

const deleteDevice = (deviceId) => api.delete(`/new/devices/${deviceId}/`);

const DeviceService = {
  getDevices,
  getDeviceDetails,
  getMyDevices,
  registerDevice,
  revokeDevice,
  regenerateToken,
  updateDevice,
  deleteDevice,
};

export default DeviceService;
